import JobPreferences from "./JobPreferences";

export default JobPreferences;
